import { Measurement } from './_types';
import { Dictionary } from '../dictionary';
import { LIB_MEASURES_GRAPES } from './meas_grapes';
import { LIB_MEASURES_FRUT_TREE } from './measures_frut_tree';
import { LIB_MEASURES_FRUT_HARVEST } from './measures_frut_harvest';
import { LIB_MEASURES_CANNABIS } from './measures_cannabis';
import { LIB_MEASURES_NUT_TREE } from './measures_nut_tree';
import { LIB_MEASURES_NUT_HARVEST } from './measures_nut_harvest';
import { LIB_MEASURES_BERRY_HARVEST } from './measures_berry_harvest';
import { LIB_MEASURES_ADVANCED_CITRUS_HARVEST } from './measures_citrus_harvest';
import { LIB_MEASURES_HARVEST_DISEASE } from './measures_harvest_disease';
import { LIB_MEASURES_HARVEST_PATHOLOGY } from './measure_harvest_pathology';
import { LIB_MEASURES_HARVEST_PHYSIOLOGY } from './measure_harvest_physiology';
import { LIB_MEASURES_FRUT_VINE } from './measures_frut_vine';

export class MeasurementDictionary extends Dictionary<Measurement>{
    constructor(){
        super([
            ...LIB_MEASURES_FRUT_TREE,
            ...LIB_MEASURES_FRUT_HARVEST,
            ...LIB_MEASURES_GRAPES,
            ...LIB_MEASURES_CANNABIS,
            ...LIB_MEASURES_NUT_TREE,
            ...LIB_MEASURES_NUT_HARVEST,
            ...LIB_MEASURES_BERRY_HARVEST,
            ...LIB_MEASURES_ADVANCED_CITRUS_HARVEST,
            ...LIB_MEASURES_HARVEST_DISEASE,
            ...LIB_MEASURES_HARVEST_PATHOLOGY,
            ...LIB_MEASURES_HARVEST_PHYSIOLOGY,
            ...LIB_MEASURES_FRUT_VINE,
        ]);
    }
}

export * from './_types';